// Announcement
$(document).ready(function () {
    $('.announcement')
      .attr({
        'role': 'region',
        'aria-label': 'Announcement'
    });

    $('footer a[href*="shopify.com"]').filter(function(){ return !$.trim($(this).text()); })
  .attr('aria-label', 'Powered by Shopify (opens in a new tab)');

  $('.noUi-handle-lower').attr('aria-label', 'Minimum price');
  $('.noUi-handle-upper').attr('aria-label', 'Maximum price');

  $('.product__thumb-item').each(function(i, el){
  var total = $('.product__thumb-item').length;
  $(el).find('a').attr('aria-label', 'View product image ' + (i + 1) + ' of ' + total);
  $(el).find('img').attr('alt', '');   
  });

  $(document).on('ajaxCart.afterCartLoad cart:updated', function(evt, cart){
  var name  = $('.product-single__title, h1').first().text().trim(),
      count = (cart && cart.item_count) || $('.cart-link__bubble-num').text() || '';
  announce(name + ' added to cart. Cart has ' + count + ' item' + (count == 1 ? '' : 's') + '.');
  });


  // Keep screen reader cart count in sync with AJAX cart updates
  $(document).on('ajaxCart.afterCartLoad cart:updated', function(e, cart) { 
    if (cart && typeof cart.item_count !== 'undefined') {
      $('[data-cart-count-a11y]').text(cart.item_count);
    } 
  });


});


// Contacy form
$(document).ready(function() {
  
  $('input[name="contact[name]"]').attr('autocomplete','name');
  $('input[name="contact[email]"]').attr('autocomplete','email');
  $('input[name="contact[phone]"]').attr('autocomplete','tel');
  
    $(function(){
    var $err = $('.form-message--error, .errors').first();
    if(!$err.length) return;
    $err.attr({'role':'alert','tabindex':'-1'}).trigger('focus');
    $err.find('a[href^="#"]').each(function(){
      var $f = $($(this).attr('href'));
      $f.attr({'aria-invalid':'true','aria-describedby':$err.attr('id') || 'form-errors'});
    });
  });

});


// List of Email aria label assigned
$(document).ready(function() {
  
  $('a[href^="mailto:"]').each(function() {
    
    let email = $(this).attr('href').replace('mailto:', '').trim();
    
    
    if (email) {
      
      email = decodeURIComponent(email)   
              .split('?')[0]              
              .split('&')[0];              
      
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (emailRegex.test(email)) {
        $(this).attr('aria-label', 'Email Address: ' + email);
      } else {
        
        console.warn('Invalid email address:', email);
      }
    }
  });
});


// Label For Phone Numbers
$(document).ready(function() {
  $('a[href^="tel:"]').each(function() {
    const telNumber = $(this).attr('href').replace('tel:', ''); 
    const ariaNumber = telNumber.replace(/-/g, '.'); 
    
    $(this).attr('aria-label', `Phone Number: ${ariaNumber}`);
  });
});


//Empty Heading issue Fixed
$(document).ready(function() {
  $('h1, h2, h3, h4, h5, h6').each(function() {
    var $heading = $(this);
    if ($.trim($heading.text()).length === 0 && $heading.children('br').length === $heading.children().length) {
      $heading.remove();
    }
  });
});


// Cart drawer JS
$(document).ready(function () {
    var $cartBtn = $('.js-drawer-open-cart');
    var $closeBtn = $('.upez--close-button');
  
    
    $cartBtn.attr({
      'role': 'button',
      'aria-expanded': 'false'
    });
  
    $closeBtn.attr({
      'role': 'button',
      'tabindex': '0',
      'aria-label': 'Close Cart Drawer'
    });
  
    $closeBtn.find('svg').attr({
      'aria-hidden': 'true',
      'focusable': 'false'
    });
  
    
    $cartBtn.on('click', function (e) {
      $cartBtn.attr('aria-expanded', 'true');
  
    
      setTimeout(function () {
        $closeBtn.trigger('focus');
      }, 150);
    });
  
    
    function closeDrawerAndReturnFocus() {
      $cartBtn.attr('aria-expanded', 'false');
      
    
      $cartBtn.trigger('focus');
    }
  
    
    $closeBtn.on('click', function () {
      closeDrawerAndReturnFocus();
    });
  
    $closeBtn.on('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
        e.preventDefault();
        $(this).trigger('click');
      }
    });
  
    
    $(document).on('keydown', function (e) {
      if (e.key === 'Escape' || e.keyCode === 27) {
        if ($cartBtn.attr('aria-expanded') === 'true') {
          $closeBtn.trigger('click');
        }
      }
    });
});


// Banner Tab index
$(document).ready(function () {
    
    var flickityContainers = [
      '[id^="Slideshow-template--"]',
      '[id^="CollectionSwitcher"]',
      '.collection-switcher__collection-grid',
      '.hero.flickity-enabled',
      '.flickity-enabled[tabindex="0"]'
    ].join(', ');
  
    function removeSliderTabIndex() {
      $(flickityContainers).removeAttr('tabindex');
    }
  
    
    removeSliderTabIndex();
    setTimeout(removeSliderTabIndex, 300);
    setTimeout(removeSliderTabIndex, 1000);
  
    
    if (window.MutationObserver) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName === 'tabindex') {
            var target = mutation.target;
            if (target && target.matches && target.matches(flickityContainers)) {
              if (target.hasAttribute('tabindex')) {
                target.removeAttribute('tabindex');
              }
            }
          }
        });
      });
  
      observer.observe(document.body, {
        attributes: true,
        subtree: true,
        attributeFilter: ['tabindex']
      });
    }
}); 

// Navigation btn
$(document).ready(function () {
    function updateFlickityLabels() {
      $('.flickity-prev-next-button.flickity-previous').attr('aria-label', 'Previous slide');
      $('.flickity-prev-next-button.flickity-next').attr('aria-label', 'Next slide');
      
      
      $('.flickity-button-icon').attr({
        'aria-hidden': 'true',
        'focusable': 'false'
      });
    }
  
    
    updateFlickityLabels();
  
    
    setTimeout(updateFlickityLabels, 300);
    setTimeout(updateFlickityLabels, 1000);
  
    
    var slider = document.querySelector('.hero.flickity-enabled, [id^="Slideshow-template--"]');
    if (slider && window.MutationObserver) {
      var observer = new MutationObserver(function () {
        var $prev = $('.flickity-prev-next-button.flickity-previous');
        var $next = $('.flickity-prev-next-button.flickity-next');
  
        if ($prev.attr('aria-label') === 'Previous') {
          $prev.attr('aria-label', 'Previous slide');
        }
        if ($next.attr('aria-label') === 'Next') {
          $next.attr('aria-label', 'Next slide');
        }
      });
  
      observer.observe(slider, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-label']
      });
    }
});


// Collection Switcher Tabs - A11y Enhancement
$(document).ready(function () {

  $('[data-section-type="collection-switcher"]').each(function () {
    var $section   = $(this);
    var $triggers  = $section.find('.collection-switcher__trigger');
    var $panels    = $section.find('.collection-switcher__collection');
    var sectionId  = $section.attr('data-section-id');

    
    if (!$triggers.length) return;

    
    var $tabTitles = $section.find('.collection-switcher__title');
    $tabTitles.wrapAll('<div class="collection-switcher__tablist"></div>');
    var $tablist = $section.find('.collection-switcher__tablist');
    $tablist.attr('role', 'tablist');

    
    $tabTitles.attr('role', 'presentation');

    
    $triggers.each(function (index) {
      var $tab     = $(this);
      var isActive = $tab.hasClass('is-active');
      var tabId    = 'tab-' + sectionId + '-' + index;

      $tab.attr({
        'role':          'tab',
        'id':            tabId,
        'aria-selected': isActive ? 'true' : 'false',
        'tabindex':      isActive ? '0' : '-1'
      });
    });

    
    $panels.each(function (index) {
      var $panel = $(this);
      var correspondingTabId = 'tab-' + sectionId + '-' + index;

      $panel.attr({
        'role':            'tabpanel',
        'aria-labelledby': correspondingTabId,
        'tabindex':        '0'
      });

      if ($panel.hasClass('hide')) {
        $panel.attr('aria-hidden', 'true');
      } else {
        $panel.attr('aria-hidden', 'false');
      }
    });

    
    $triggers.on('click', function () {
      var $clickedTab = $(this);

      $triggers.each(function () {
        var $t = $(this);
        var isNowActive = $t.is($clickedTab);
        $t.attr({
          'aria-selected': isNowActive ? 'true' : 'false',
          'tabindex':      isNowActive ? '0' : '-1'
        });
      });

      
      setTimeout(function () {
        $panels.each(function () {
          var $p = $(this);
          $p.attr('aria-hidden', $p.hasClass('hide') ? 'true' : 'false');
        });
      }, 50);
    });

    
    $triggers.on('keydown', function (e) {
      var $current = $(this);
      var index    = $triggers.index($current);
      var newIndex = null;

      if (e.key === 'ArrowRight' || e.keyCode === 39) {
        e.preventDefault();
        newIndex = (index + 1) % $triggers.length;
      } else if (e.key === 'ArrowLeft' || e.keyCode === 37) {
        e.preventDefault();
        newIndex = (index - 1 + $triggers.length) % $triggers.length;
      } else if (e.key === 'Home' || e.keyCode === 36) {
        e.preventDefault();
        newIndex = 0;
      } else if (e.key === 'End' || e.keyCode === 35) {
        e.preventDefault();
        newIndex = $triggers.length - 1;
      }

      if (newIndex !== null) {
        $triggers.eq(newIndex).trigger('focus').trigger('click');
      }
    });
  });
});


// Social Links - A11y Enhancement
$(document).ready(function () {
  $('.social-icons a[title]').each(function () {
    $(this).attr('aria-label', $(this).attr('title'));
  });
});


// Newsletter Footer - Focus success message for screen readers
$(document).ready(function () {
  var $success = $('#newsletter-footer-success');
  if ($success.length) {
    
    setTimeout(function () {
      $success.trigger('focus');
    }, 150);
  }
});


// Search Drawer - Focus return & aria-expanded management
$(document).ready(function () {
  var lastSearchTrigger = null;

  
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.js-search-header');
    if (trigger) {
      lastSearchTrigger = trigger;
  
      document.querySelectorAll('.js-search-header').forEach(function (el) {
        el.setAttribute('aria-expanded', el === trigger ? 'true' : 'false');
      });
    }
  }, true); 

  
  document.addEventListener('predictive-search:close-all', function () {
  
    document.querySelectorAll('.js-search-header').forEach(function (el) {
      el.setAttribute('aria-expanded', 'false');
    });

  
    var triggerEl = lastSearchTrigger;
    lastSearchTrigger = null;

    if (!triggerEl || triggerEl.offsetParent === null) {
      triggerEl = document.querySelector('.js-search-header');
  
      var allTriggers = document.querySelectorAll('.js-search-header');
      for (var i = 0; i < allTriggers.length; i++) {
        if (allTriggers[i].offsetParent !== null) {
          triggerEl = allTriggers[i];
          break;
        }
      }
    }

    
    if (triggerEl) {
      setTimeout(function () {
        if (triggerEl.offsetParent !== null) {
          triggerEl.focus();
        }
      }, 350);
    }
  });
});



// Desktop Nav — Click-based Dropdowns (Accessibility)
//
// Works with the updated header-desktop-nav.liquid which now renders:
//   <li class="site-nav__item site-nav--has-dropdown [site-nav--is-megamenu]">
//     <a href="…" class="site-nav__link …">BELTS</a>          ← pure link, no toggle
//     <button class="site-nav__chevron-btn" aria-controls="site-nav-item--1">SVG</button>  ← toggle only
//     <div id="site-nav-item--1" class="site-nav__dropdown …">…</div>  ← dropdown panel
//   </li>
//
// Accessibility features:
//  • <a> link and <button> chevron are true siblings — no nested interactive elements
//  • Chevron button: aria-expanded, aria-controls, aria-haspopup, aria-label
//  • ESC key closes the open dropdown and returns focus to the chevron button
//  • Click outside nav closes all open dropdowns
//  • Opening one dropdown automatically closes any previously open dropdown
//  • CSS :hover suppressed — dropdown only opens on chevron click
//
$(document).ready(function () {

  var $nav = $('.site-nav.site-navigation');
  if (!$nav.length || $nav.data('clickNavDone')) return;
  $nav.data('clickNavDone', true);
  $nav.addClass('js-click-nav');

  // ── 1. Inject CSS ─────────────────────────────────────────────────────────
  //    a) Suppress CSS :hover from opening the dropdown (was hover-based)
  //    b) Replace  details[open] > .site-nav__dropdown  rules with
  //       .is-open-based equivalents (since <details> no longer exists)
  //    c) Style the chevron button (invisible chrome, inherits link colour)
  if (!document.getElementById('js-click-nav-styles')) {
    var styleEl = document.createElement('style');
    styleEl.id  = 'js-click-nav-styles';
    styleEl.textContent = [

      /* ── Suppress :hover from opening the dropdown ───────────────── */
      '.js-click-nav .site-nav--has-dropdown:hover > .site-nav__dropdown,',
      '.js-click-nav .site-nav--has-dropdown:hover > ul.site-nav__dropdown {',
      '  visibility: hidden !important;',
      '  transform:  translate3d(0px,-25px,0px) !important;',
      '  transition: none !important;',
      '}',

      /* ── Suppress megamenu appear-animation on hover ─────────────── */
      '.js-click-nav .site-nav--is-megamenu:hover .appear-animation {',
      '  opacity:             0   !important;',
      '  transform:           translateY(-10px) !important;',
      '  transition-duration: 0s  !important;',
      '}',

      /* ── Show dropdown when JS sets .is-open on the <li> ─────────── */
      /* (replaces the removed  details[open] > .site-nav__dropdown  rule) */
      '.js-click-nav .site-nav__item.is-open > .site-nav__dropdown {',
      '  visibility: visible !important;',
      '  transform:  translateZ(0) !important;',
      '  transition: all 500ms cubic-bezier(0.2,0.06,0.05,0.95) !important;',
      '}',

      /* ── Fade in list items when open ────────────────────────────── */
      /* (replaces  details[open] > .site-nav__dropdown li  rule) */
      '.js-click-nav .site-nav__item.is-open > .site-nav__dropdown li {',
      '  opacity:    1 !important;',
      '  transition: opacity 0.5s ease !important;',
      '}',

      /* ── Megamenu appear-animations when open ────────────────────── */
      /* (the existing  .site-nav--is-megamenu.is-focused .appear-animation */
      /*  rule already fires because we also add .is-focused; this is a    */
      /*  belt-and-braces override)                                         */
      '.js-click-nav .site-nav__item.is-open .appear-animation {',
      '  opacity:             1    !important;',
      '  transform:           translateY(0) !important;',
      '  transition-duration: 0.5s !important;',
      '}',

      /* ── Chevron button: no chrome, inherits link colour ─────────── */
      '.site-nav__chevron-btn {',
      '  background:     none;',
      '  border:         none;',
      '  padding:        0 0 0 5px;',
      '  margin:         0;',
      '  cursor:         pointer;',
      '  display:        inline-flex;',
      '  align-items:    center;',
      '  vertical-align: middle;',
      '  color:          inherit;',
      '  line-height:    1;',
      '}',
      '.site-nav__chevron-btn svg {',
      '  width:          14px;',
      '  height:         8px;',
      '  pointer-events: none;',
      '  transition:     transform 0.3s ease;',
      '}',
      /* Force white chevron — CSS overrides SVG presentation attributes */
      '.site-nav__chevron-btn svg path {',
      '  stroke: #fff !important;',
      '}',
      /* Rotate chevron arrow when the dropdown is open */
      '.site-nav__chevron-btn[aria-expanded="true"] svg {',
      '  transform: rotate(180deg);',
      '}',
      /* Visible focus ring on the chevron button for keyboard users */
      '.site-nav__chevron-btn:focus-visible {',
      '  outline:        2px solid #fff;',
      '  outline-offset: 2px;',
      '  border-radius:  2px;',
      '}',
      /* Fallback for browsers that don't support :focus-visible */
      '.site-nav__chevron-btn:focus:not(:focus-visible) {',
      '  outline: none;',
      '}'


    ].join('\n');
    document.head.appendChild(styleEl);
  }

  // ── 2. State ──────────────────────────────────────────────────────────────
  var $currentOpen = null; // jQuery ref to the currently open <li>

  // ── 3. Open ───────────────────────────────────────────────────────────────
  function openDropdown($li, $btn) {
    $btn.attr('aria-expanded', 'true');
    // is-open  → our injected CSS makes .site-nav__dropdown visible
    // is-focused → existing theme CSS fires megamenu appear-animations +
    //              underline on the nav link (via .site-nav--has-dropdown.is-focused > a)
    $li.addClass('is-open is-focused');
    $currentOpen = $li;
  }

  // ── 4. Close ──────────────────────────────────────────────────────────────
  function closeDropdown($li, $btn, returnFocus) {
    $btn.attr('aria-expanded', 'false');
    $li.removeClass('is-open is-focused');
    if ($currentOpen && $currentOpen[0] === $li[0]) $currentOpen = null;
    if (returnFocus) $btn.trigger('focus'); // ESC → return focus to chevron
  }

  // ── 5. Wire up each nav item ──────────────────────────────────────────────
  $nav.find('.site-nav__item.site-nav--has-dropdown').each(function () {
    var $li  = $(this);
    var $btn = $li.find('> .site-nav__chevron-btn').first();

    // Skip if the button isn't present (shouldn't happen with updated Liquid)
    if (!$btn.length) return;

    // ── 5a. Chevron button click → toggle dropdown ────────────────────────
    $btn.on('click', function () {
      if ($li.hasClass('is-open')) {
        closeDropdown($li, $btn, false);
      } else {
        // Close whichever dropdown is currently open first (one at a time)
        if ($currentOpen && $currentOpen[0] !== $li[0]) {
          var $prevBtn = $currentOpen.find('> .site-nav__chevron-btn').first();
          closeDropdown($currentOpen, $prevBtn, false);
        }
        openDropdown($li, $btn);
      }
    });

    // ── 5b. ESC key → close + return focus to chevron button ─────────────
    $li.on('keydown', function (e) {
      if ((e.key === 'Escape' || e.keyCode === 27) && $li.hasClass('is-open')) {
        e.stopPropagation();
        closeDropdown($li, $btn, true /* returnFocus */);
      }
    });

    // ── 5c. focusout → collapse when focus leaves the nav item ───────────
    //    `focusout` bubbles, so one listener on <li> catches all focus
    //    losses from within it (link, chevron button, dropdown links).
    //    `e.relatedTarget` is the element RECEIVING focus next.
    //    If it's null (focus left the page) or not inside this <li>,
    //    the user has tabbed away → close the dropdown.
    $li.on('focusout', function (e) {
      if (!$li.hasClass('is-open')) return;
      var movingTo = e.relatedTarget;
      if (!movingTo || !$li[0].contains(movingTo)) {
        closeDropdown($li, $btn, false);
      }
    });
  });

  // ── 6. Click outside nav → close all open dropdowns ──────────────────────
  $(document).on('click.navClickOutside', function (e) {
    if ($currentOpen && !$nav[0].contains(e.target)) {
      $nav.find('.site-nav__item.is-open').each(function () {
        var $li  = $(this);
        var $btn = $li.find('> .site-nav__chevron-btn').first();
        closeDropdown($li, $btn, false);
      });
    }
  });

  // ── 7. Re-init after Shopify theme editor reloads the header section ──────
  document.addEventListener('shopify:section:load', function () {
    $(document).off('click.navClickOutside');
    $nav.removeData('clickNavDone').removeClass('js-click-nav');
    // Re-run the whole block by resetting and recalling init
    $nav = $('.site-nav.site-navigation');
    if (!$nav.length || $nav.data('clickNavDone')) return;
    $nav.data('clickNavDone', true).addClass('js-click-nav');
    $currentOpen = null;

    $nav.find('.site-nav__item.site-nav--has-dropdown').each(function () {
      var $li  = $(this);
      var $btn = $li.find('> .site-nav__chevron-btn').first();
      if (!$btn.length) return;
      $btn.off('click').on('click', function () {
        if ($li.hasClass('is-open')) { closeDropdown($li, $btn, false); }
        else { if ($currentOpen && $currentOpen[0] !== $li[0]) { closeDropdown($currentOpen, $currentOpen.find('> .site-nav__chevron-btn').first(), false); } openDropdown($li, $btn); }
      });
      $li.off('keydown.navEsc').on('keydown.navEsc', function (e) {
        if ((e.key === 'Escape' || e.keyCode === 27) && $li.hasClass('is-open')) { e.stopPropagation(); closeDropdown($li, $btn, true); }
      });
    });

    $(document).on('click.navClickOutside', function (e) {
      if ($currentOpen && !$nav[0].contains(e.target)) {
        $nav.find('.site-nav__item.is-open').each(function () {
          var $l = $(this); closeDropdown($l, $l.find('> .site-nav__chevron-btn').first(), false);
        });
      }
    });
  });

});